import script from "./InvoiceRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceRow.vue?vue&type=style&index=0&id=19bd6414&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bd6414"]])

export default __exports__